import { AnyAction } from 'redux';

import { ECLASSES_RECEIVED } from './../actions/eclass-actions';
import { EclassDto } from '../models/eclass-dto';

export interface EclassReducerState {
    eclasses: EclassDto[];
}

export const initialEclassReducerState: EclassReducerState = {
    eclasses: [],
};

export const eclassReducer = (
    state: EclassReducerState = initialEclassReducerState,
    action: AnyAction
): EclassReducerState => {
    const { type } = action;

    switch (type) {
        case ECLASSES_RECEIVED: {
            return {
                ...state,
                eclasses: action['eclasses'],
            };
        }

        default: {
            return state;
        }
    }
};
